module.exports = __webpack_public_path__ + "img/banner-cagliari.17378948.jpg";